import { HistoryEventType } from "../../../../../messages/scripting/ScriptMessages";
import { historyEventService } from "../../../../../modules/multiplayer/peer";
import { usersService } from "../../../../../modules/multiplayer/UsersService";
import { fileService } from "../../../../../modules/files";
import { MessageService } from "../../../../services/message.service";
import React from "react";
import i18next from "i18next";
import { ownUsernameDisplayText } from "../../../../common-strings.util";
export var EventHistoryUtils;
(function (EventHistoryUtils) {
    EventHistoryUtils.ttSendMessageButton = () => i18next.t("chatview:button-send-message-tooltip", "Send message to all users");
    EventHistoryUtils.ttSendMessageButtonDisabled = () => i18next.t("chatview:button-send-message-tooltip-disabled", "Type a message to send");
    EventHistoryUtils.placeholderTypeAMessage = () => i18next.t("chatview:placeholder-type-a-message", "Type a message...");
    let EventHistoryOverlayViewMode;
    (function (EventHistoryOverlayViewMode) {
        EventHistoryOverlayViewMode[EventHistoryOverlayViewMode["expanded"] = 0] = "expanded";
        EventHistoryOverlayViewMode[EventHistoryOverlayViewMode["reduced"] = 1] = "reduced";
        EventHistoryOverlayViewMode[EventHistoryOverlayViewMode["hideAll"] = 2] = "hideAll";
    })(EventHistoryOverlayViewMode = EventHistoryUtils.EventHistoryOverlayViewMode || (EventHistoryUtils.EventHistoryOverlayViewMode = {}));
    const eventHistoryOptionKey = "eventHistoryOptions";
    function loadEventHistoryOptions() {
        const optionsString = localStorage.getItem(eventHistoryOptionKey);
        if (optionsString) {
            try {
                const options = JSON.parse(optionsString);
                return options;
            }
            catch (error) {
                console.error(`Could not parse event history options from local storage: ${String(error)}`);
            }
        }
        return {};
    }
    EventHistoryUtils.loadEventHistoryOptions = loadEventHistoryOptions;
    function persistEventHistoryOptions(options) {
        const previousOptions = loadEventHistoryOptions();
        const newOptions = Object.assign(Object.assign({}, previousOptions), options);
        localStorage.setItem(eventHistoryOptionKey, JSON.stringify(newOptions));
    }
    EventHistoryUtils.persistEventHistoryOptions = persistEventHistoryOptions;
    function extractLinks(text) {
        var _a;
        const result = [];
        const regex = /(((https?)|(ftp)):\/\/[^\s]+)|((www\.)[a-zA-Z0-9._-]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/gi;
        result.push(...((_a = text.match(regex)) !== null && _a !== void 0 ? _a : []));
        return result;
    }
    function extractMails(text) {
        var _a;
        const mailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]{1,256}\.[a-zA-Z0-9_-]{1,6})/gi;
        return (_a = text.match(mailRegex)) !== null && _a !== void 0 ? _a : [];
    }
    function splitChatMessageIntoParts(text) {
        const preResult = [];
        const links = extractLinks(text);
        const mails = extractMails(text);
        preResult.push(...splitPartByLinksOrMails(text, links, "link"));
        const result = [];
        for (const element of preResult) {
            if (element.type === "text") {
                const tempParts = splitPartByLinksOrMails(element.text, mails, "mail");
                for (const tempPart of tempParts) {
                    if (tempPart.type === "text") {
                        result.push(...splitPartByLinebreaks(tempPart.text));
                    }
                    else {
                        result.push(tempPart);
                    }
                }
            }
            else {
                result.push(element);
            }
        }
        return result;
    }
    EventHistoryUtils.splitChatMessageIntoParts = splitChatMessageIntoParts;
    function splitPartByLinksOrMails(text, testStrings, testType) {
        const result = [];
        let remainingText = text;
        for (const testString of testStrings) {
            const index = remainingText.indexOf(testString);
            if (index > 0) {
                result.push({
                    text: remainingText.substring(0, index),
                    type: "text"
                });
            }
            if (index !== undefined && index >= 0) {
                result.push({
                    text: testString,
                    type: testType
                });
                remainingText = text.substring(text.indexOf(testString) + testString.length);
            }
        }
        if (remainingText.length > 0) {
            result.push({
                text: remainingText,
                type: "text"
            });
        }
        return result;
    }
    function splitPartByLinebreaks(text) {
        const result = [];
        const parts = text.split("\n");
        for (let i = 0; i < parts.length; i++) {
            result.push({
                text: parts[i],
                type: "text"
            });
            if (i < parts.length - 1) {
                result.push({
                    text: "",
                    type: "linebreak"
                });
            }
        }
        return result;
    }
    function fixUrl(url) {
        const protocolRegex = /^((https?)|(ftp)):\/\//i;
        return protocolRegex.test(url) ? url : `//${url}`;
    }
    EventHistoryUtils.fixUrl = fixUrl;
    function getShortenedDisplayUrl(url) {
        if (url.length <= 40) {
            return url;
        }
        const protocolRegex = /^(((https?)|(ftp)):)?\/\//i;
        const withoutProtocol = url.replace(protocolRegex, "");
        if (withoutProtocol.length <= 40) {
            return withoutProtocol;
        }
        const parts = withoutProtocol.split("/");
        let shortUrl = parts[0] + "/";
        if (shortUrl.length > 37) {
            return shortUrl + "...";
        }
        const urlAfterDomain = parts.slice(1).join("/");
        const splitPosition = Math.floor(37 - shortUrl.length);
        shortUrl += urlAfterDomain.substring(0, splitPosition) + "...";
        return shortUrl;
    }
    EventHistoryUtils.getShortenedDisplayUrl = getShortenedDisplayUrl;
    function getUsername(event) {
        let name = event.userName;
        if (event.params.clientId === usersService.getLocalUser().clientId) {
            name = ownUsernameDisplayText(name);
        }
        return name;
    }
    EventHistoryUtils.getUsername = getUsername;
    function getIconName(description) {
        switch (description) {
            case HistoryEventType.modelUpload:
                return "cubes";
            case HistoryEventType.annotation:
                return "sticky-note";
            case HistoryEventType.moisture:
                return "tint";
            case HistoryEventType.distance:
                return "ruler";
            case HistoryEventType.photo:
                return "camera";
            case HistoryEventType.chatMessage:
                return "comment";
            case HistoryEventType.userJoined:
                return "user";
            case HistoryEventType.userLeft:
                return "user-slash";
            case HistoryEventType.startRecording:
                return "dot-circle";
            case HistoryEventType.stopRecording:
                return "stop-circle";
            default:
                return "question";
        }
    }
    EventHistoryUtils.getIconName = getIconName;
    function getIconTooltip(description) {
        switch (description) {
            case HistoryEventType.modelUpload:
                return i18next.t("chatview:eventtype-model-upload", "Model upload");
            case HistoryEventType.annotation:
                return i18next.t("chatview:eventtype-annotation-added", "Annotation added");
            case HistoryEventType.moisture:
                return i18next.t("chatview:eventtype-misture-measurement", "Moisture measurement");
            case HistoryEventType.distance:
                return i18next.t("chatview:eventtype-distance-measurement", "Distance measurement");
            case HistoryEventType.photo:
                return i18next.t("chatview:eventtype-photo", "Photo taken");
            case HistoryEventType.chatMessage:
                return i18next.t("chatview:eventtype-chat-message", "Chat message");
            case HistoryEventType.userJoined:
                return i18next.t("chatview:eventtype-user-joined", "User Joined");
            case HistoryEventType.userLeft:
                return i18next.t("chatview:eventtype-user-left", "User left");
            case HistoryEventType.startRecording:
                return i18next.t("chatview:eventtype-recording-started", "Recording started");
            case HistoryEventType.stopRecording:
                return i18next.t("chatview:eventtype-recording-ended", "Recording stopped");
            default:
                return undefined;
        }
    }
    EventHistoryUtils.getIconTooltip = getIconTooltip;
    function isCopyAllowed(params) {
        if (!params.type || !params.value) {
            return false;
        }
        switch (params.type) {
            case HistoryEventType.chatMessage:
            case HistoryEventType.moisture:
            case HistoryEventType.distance:
            case HistoryEventType.photo:
                return true;
            default:
                return false;
        }
    }
    EventHistoryUtils.isCopyAllowed = isCopyAllowed;
    function copyToClipboard(params) {
        if (!EventHistoryUtils.isCopyAllowed(params) || !params.value) {
            return;
        }
        if (params.type === HistoryEventType.photo) {
            fileService
                .copyDataToClipboardByUrl(params.value)
                .then((success) => {
                if (success) {
                    MessageService.showMessage("success", i18next.t("chatview:toast-image-copied-to-clipboard", "Image copied to clipboard"));
                }
                else {
                    MessageService.showMessage("error", i18next.t("chatview:error-copy-image-to-clipboard", "Could not copy image to clipboard from url {{value}}", { value: params.value }));
                }
            })
                .catch((error) => {
                MessageService.showMessage("error", i18next.t("chatview:error-copy-image-to-clipboard-extended", "Could not copy image to clipboard from url {{value}}: {{error}}", {
                    value: params.value,
                    error: error
                }));
            });
        }
        else {
            navigator.clipboard
                .writeText(params.value)
                .then(() => {
                MessageService.showMessage("success", i18next.t("chatview:toast-text-copied-to-clipboard", "Text copied to clipboard"));
            })
                .catch((error) => {
                MessageService.showMessage("error", i18next.t("chatview:error-copy-text-to-clipboard", "Could not copy text to clipboard: {{error}}", { error: error }));
            });
        }
    }
    EventHistoryUtils.copyToClipboard = copyToClipboard;
    EventHistoryUtils.sendChatMessage = (message) => {
        if (message) {
            historyEventService.broadCastHistoryEvent({
                type: HistoryEventType.chatMessage,
                value: message,
                clientId: usersService.getLocalUser().clientId
            });
        }
    };
    EventHistoryUtils.createChatMessageElement = (params) => {
        var _a;
        const parts = EventHistoryUtils.splitChatMessageIntoParts((_a = params.value) !== null && _a !== void 0 ? _a : "");
        return (React.createElement("span", { className: "event-history-item-content-text" }, parts.map((part, index) => {
            if (part.type === "link") {
                return (React.createElement("a", { key: index, href: EventHistoryUtils.fixUrl(part.text), target: "_blank", rel: "noreferrer" }, EventHistoryUtils.getShortenedDisplayUrl(part.text)));
            }
            else if (part.type === "mail") {
                return (React.createElement("a", { key: index, href: `mailto:${part.text}` }, part.text));
            }
            else if (part.type === "linebreak") {
                return React.createElement("br", { key: index });
            }
            else {
                return part.text;
            }
        })));
    };
    EventHistoryUtils.createValueElement = (params) => {
        if (!params.type || !params.value) {
            return null;
        }
        else if (params.type === HistoryEventType.photo) {
            return React.createElement("img", { className: "event-history-item-content-image", src: params.value });
        }
        else if (params.type === HistoryEventType.userJoined) {
            return (React.createElement("span", { className: "event-history-item-content-text" }, i18next.t("chatview:message-user-joined", "{{name}} joined the session", { name: params.value })));
        }
        else if (params.type === HistoryEventType.userLeft) {
            return (React.createElement("span", { className: "event-history-item-content-text" }, i18next.t("chatview:message-user-left", "{{name}} left the session", { name: params.value })));
        }
        else if (params.type === HistoryEventType.startRecording) {
            return React.createElement("span", { className: "event-history-item-content-text" }, i18next.t("chatview:message-recording-started", "Recording started"));
        }
        else if (params.type === HistoryEventType.stopRecording) {
            return React.createElement("span", { className: "event-history-item-content-text" }, i18next.t("chatview:message-recording-ended", "Recording stopped"));
        }
        else if (params.type === HistoryEventType.chatMessage) {
            return EventHistoryUtils.createChatMessageElement(params);
        }
        else if (params.type === HistoryEventType.distance) {
            return (React.createElement("span", { className: "event-history-item-content-text" }, i18next.t("chatview:message-distance-measurement", "Distance: {{value}}", { value: params.value })));
        }
        else if (params.type === HistoryEventType.moisture) {
            return (React.createElement("span", { className: "event-history-item-content-text" }, i18next.t("chatview:message-moisture-measurement", "Moisture: {{value}}", { value: params.value })));
        }
        else {
            return React.createElement("span", { className: "event-history-item-content-text" }, params.value);
        }
    };
    EventHistoryUtils.getItemClassNames = (clientId, mode) => {
        const classNames = [mode === "panel" ? "event-history-panel-item" : "event-history-overlay-item"];
        if (clientId === usersService.getLocalUser().clientId) {
            classNames.push(mode === "panel" ? "event-history-panel-item-me" : "event-history-overlay-item-me");
        }
        return classNames.join(" ");
    };
})(EventHistoryUtils || (EventHistoryUtils = {}));
